import loadable from '@loadable/component';
import loadableModule from '../../loadable-module';

const DestinationsModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "mlp-destinations"  */
            './Destinations'
        )
    ),
    componentName: 'Destinations',
    placeholder: {
        cardType: 'CardType1',
        placeholderType: 'Carousel',
        size: 'md',
    },
});
export default DestinationsModule;
